@if (links) {
<div class="link-list" [class.link-list--expanded]="linksExpanded">
  <div class="link-list__content link-list__hidden" #referenceElement>
    @for (link of links; track identifyLink($index, link); let last = $last) {
    <a
      class="link"
      [class.hide-border]="last && links.length <= limit"
      [href]="link?.path"
      target="_blank"
      rel="nofollow noopener"
      (middleclick)="linkClick.emit({ link: link, element: $event.currentTarget })"
      (click)="linkClick.emit({ link: link, element: $event.currentTarget })">
      <div class="name" [ngClass]="{ 'name--link': !link?.text }">
        {{ link?.text ?? link?.path ?? 'N/A' }}
      </div>
      <div class="button">
        <mat-icon>open_in_new</mat-icon>
      </div>
    </a>
    }
  </div>
  <div class="link-list__content link-list__hidden link-list__hidden--collapsed" #linkElement>
    @for (link of links | slice : 0 : 3; track identifyLink($index, link); let last = $last) {
    <a
      class="link"
      [class.hide-border]="last && links.length <= limit"
      [href]="link?.path"
      target="_blank"
      rel="nofollow noopener"
      (middleclick)="linkClick.emit({ link: link, element: $event.currentTarget })"
      (click)="linkClick.emit({ link: link, element: $event.currentTarget })">
      <div class="name" [ngClass]="{ 'name--link': !link?.text }">
        {{ link?.text ?? link?.path ?? 'N/A' }}
      </div>
      <div class="button">
        <mat-icon>open_in_new</mat-icon>
      </div>
    </a>
    }
  </div>
  <div class="link-list__content" [ngStyle]="{ 'max-height.px': maxHeight }">
    @for (link of links; track identifyLink($index, link); let last = $last) {
    <a
      class="link"
      [class.hide-border]="last && links.length <= limit"
      [href]="link?.path"
      target="_blank"
      rel="nofollow noopener"
      (middleclick)="linkClick.emit({ link: link, element: $event.currentTarget })"
      (click)="linkClick.emit({ link: link, element: $event.currentTarget })">
      <div class="name" [ngClass]="{ 'name--link': !link?.text }">
        {{ link?.text ?? link?.path ?? 'N/A' }}
      </div>
      <div class="button">
        <mat-icon>open_in_new</mat-icon>
      </div>
    </a>
    }
  </div>
  @if (linksOverflowing) {
  <div class="expand-list">
    @if (!linksExpanded) {
    <button class="expand-list__button mat-body-2" (click)="toggle()" i18n="@@featureProductDetails-pageTabLinks-more">
      + Alle anzeigen ({{ links.length }})
    </button>
    } @if (linksExpanded) {
    <button class="expand-list__button mat-body-2" (click)="toggle()" i18n="@@featureProductDetails-pageTabLinks-less"
      >- Weniger anzeigen</button
    >
    }
  </div>
  }
</div>
}
